import { EDIT_THRESHOLD_IN_MINUTES } from '@/shared/config'
import { PopupDatabase, saveLastState } from '@/popup/storage/Database'
import { LastPopupState } from '@/shared/models/Profile'

export const checkForLastPopupState = async (
  address?: string
): Promise<LastPopupState | undefined> => {
  let lastPopupState: LastPopupState | undefined
  lastPopupState = await PopupDatabase.getLastPopupState(address)
  if (
    lastPopupState &&
    Date.now() - lastPopupState.timestamp >
      EDIT_THRESHOLD_IN_MINUTES * 60 * 1000
  ) {
    await saveLastState(undefined, address)
    lastPopupState = undefined
  }
  return lastPopupState
}
